import { InlineValuePopover, Input } from "@xola/ui-kit";
import clsx from "clsx";
import React, { ReactNode } from "react";

interface NumberInlineValuePopoverProps {
    isOpen: boolean;
    value?: number;
    text: ReactNode;
    error?: string;
    classNames?: { input?: string; text?: string };
    min?: string | number;
    step?: string;
    disabled?: boolean;
    autoSelectOnClick?: boolean;
    clearable?: boolean;
    showArrow?: boolean;
    onOpenChange: (value: boolean) => void;
    onChange: (value: number) => void;
}

export const NumberInlineValuePopover = ({
    isOpen,
    value,
    text,
    error,
    classNames,
    min,
    step,
    disabled = false,
    autoSelectOnClick = false,
    clearable = false,
    showArrow = true,
    onOpenChange,
    onChange,
}: NumberInlineValuePopoverProps) => {
    const handleOutsideClick = () => onOpenChange(false);
    const handleInputChange = (e: any) => onChange(Number(e.target.value || 0));

    const handleInlinePopoverClick = (e: any) => {
        onOpenChange(!isOpen);
        preventEventDefault(e);
    };

    let inputValue: number | undefined = 0;
    if (value || clearable) {
        inputValue = value;
    }

    return (
        <InlineValuePopover
            showArrow={showArrow}
            autoSelectOnClick={autoSelectOnClick}
            text={text}
            error={error}
            placement="top-start"
            isOpen={isOpen}
            classNames={{
                text: clsx("px-0.5 pb-0.5 mx-1 text-gray-darker whitespace-pre border-black", classNames?.text),
            }}
            onClick={handleInlinePopoverClick}
            onClickOutside={handleOutsideClick}
        >
            <Input
                type="number"
                disabled={disabled}
                min={min}
                step={step}
                value={inputValue}
                className={classNames?.input}
                onClick={preventEventDefault}
                onChange={handleInputChange}
            />
        </InlineValuePopover>
    );
};

const preventEventDefault = (e: any) => {
    e.preventDefault();
};
